/**
 * Component overrides (i.e. global styles, default props) applied to
 * MuiStack to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/stack/#css
 */ export const MuiStack = {};

//# sourceMappingURL=stack-overrides.js.map